

































import { Component, Vue, Watch } from 'vue-property-decorator'
import { State, namespace } from 'vuex-class'

import { windowOpen } from '@common/loan-act/util'
import closeView from '@common/client/src/closeView'
import { RUN_SIDE } from '@common/loan-act/env'
import BoxTitle from './_components/boxTitle.vue'
import DescIntr from './_components/descIntr.vue'
import Marquee from '../components/marquee'
import RollerSquare from './_components/rollerSquare.vue'
import BooksSlider from './_components/booksSlider.vue'
import RulePop from './_components/rule-pop/rule-pop.vue'
import './_components/act-pop/index'

import { ACT_CODE, SHARE_CONF, AWARD_URL, BOOKS_URL } from '$utils/act-config'
import share from '$utils/share/index'
import { synRuleDrawEnhance } from '$services/act'

const actModule = namespace('act')

@Component({
  components: {
    BoxTitle,
    DescIntr,
    Marquee,
    RollerSquare,
    BooksSlider,
    RulePop
  }
})
export default class Index extends Vue {
  @State(state => state.common.loginState) isLogin!: boolean
  @actModule.Getter status!: string
  @actModule.Getter ruleGroup!: any
  @actModule.Action init!: (params?: any) => Promise<any>
  @actModule.Action getIntegral!: (params?: any) => Promise<any>
  actCode = ACT_CODE
  runSide = RUN_SIDE
  rulePopup = false
  @Watch('isLogin')
  async onIsLoginChange(isLogin: boolean) {
    console.log('已登录，获取用户加密', isLogin)
    if (isLogin) {
      this.getIntegral()
    }
  }
  visibleHandler() {
    if (document.visibilityState === 'visible') {
      this.pageInit()
    }
  }
  async pageInit() {
    await this.init()
  }
  async created() {
    this.pageInit()
    document.addEventListener('visibilitychange', this.visibleHandler)
  }
  mounted() {
    this.$buryPoint.report('act/KEY_1')
  }
  showRules() {
    this.rulePopup = true
  }
  showAward() {
    if (this.isLogin) {
      windowOpen(AWARD_URL)
    } else {
      this.$store.dispatch('normalLogin')
    }
  }
  useTravelBooks() {
    if (RUN_SIDE === 'h5') {
      windowOpen(SHARE_CONF.url)
    } else {
      window.location.href = BOOKS_URL
      setTimeout(() => {
        closeView()
      }, 600)
    }
  }
  async shareAct() {
    const { title, content, url } = SHARE_CONF
    if (RUN_SIDE === 'h5') {
      windowOpen(url)
      return
    }
    if (!this.isLogin) {
      this.$store.dispatch('normalLogin')
      return
    }
    share(title, content, url).then(() => {})

    const { uiComponentCode, ruleGroupCode } = this.ruleGroup
    const p = {
      uiComponentCode: [uiComponentCode],
      ruleGroupCodes: [ruleGroupCode],
      materialCode: this.actCode
    }
    synRuleDrawEnhance(p)
      .then(() => {
        this.getIntegral()
      })
  }
}
